export const SALUTATIONS = {
	'f': 'Frau',
	'm': 'Herr',
	'x': 'Divers',
};

export function getLabel (value)
{
	return SALUTATIONS[value];
}